<template>
  <li style="cursor: pointer" :class="{'is--read' : notification.isRead}" @click.prevent="notification.isDownload ? openLink() : $inertia.visit(route('notification.redirect', notification.id))">
    {{ notification.text }}
  </li>
</template>


<script>

export default {
  props: ['notification'],
  setup(props){
    return {
      openLink(){
        window.open(route('notification.redirect', props.notification.id))
      }
    }
  }
}
</script>
